import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

/** Respuesta de GET composicion (ingrediente activo en la UI). */
export interface IngredienteActivoApi {
    id: number;
    funcionQuimicaId: number;
    nombre: string;
    codigo: string;
    estado: string;
}

export interface IngredienteActivoFiltros {
    id?: number;
    tipoProductoId?: number;
    /** Id de funcion_quimica (grupo nutricional en filtros de la UI). */
    grupoNutricionalId?: number;
    estado?: string;
}

@Injectable({
    providedIn: 'root',
})
export class IngredienteActivoService {
    private readonly _apiUrl = environment.apiSiriUrl;

    public constructor(private http: HttpClient) {}

    public getIngredientesActivos(
        filtros: IngredienteActivoFiltros = {}
    ): Observable<IngredienteActivoApi[]> {
        if (
            filtros.grupoNutricionalId !== undefined &&
            filtros.grupoNutricionalId !== null
        ) {
            return this.getIngredientesActivosPorFuncionQuimica(
                filtros.grupoNutricionalId,
                filtros.estado,
                filtros.tipoProductoId
            );
        }

        let params = new HttpParams();
        if (filtros.id !== undefined) {
            params = params.set('id', String(filtros.id));
        }
        if (filtros.tipoProductoId !== undefined) {
            params = params.set(
                'tipoProductoId',
                String(filtros.tipoProductoId)
            );
        }
        if (filtros.estado !== undefined) {
            params = params.set('estado', filtros.estado);
        }
        return this.http.get<IngredienteActivoApi[]>(
            `${this._apiUrl}composicion`,
            { params }
        );
    }

    public getIngredientesActivosPorFuncionQuimica(
        funcionQuimicaId: number,
        estado?: string,
        tipoProductoId?: number
    ): Observable<IngredienteActivoApi[]> {
        let params = new HttpParams();
        if (tipoProductoId !== undefined) {
            params = params.set('tipoProductoId', String(tipoProductoId));
        }
        if (estado !== undefined) {
            params = params.set('estado', estado);
        }
        return this.http.get<IngredienteActivoApi[]>(
            `${this._apiUrl}composicion/funcion-quimica/${funcionQuimicaId}`,
            { params }
        );
    }
}
